import { render, staticRenderFns } from "./NavbarLocaleSwitcher.vue?vue&type=template&id=6edd3a5f"
import script from "./NavbarLocaleSwitcher.vue?vue&type=script&lang=js"
export * from "./NavbarLocaleSwitcher.vue?vue&type=script&lang=js"
import style0 from "./NavbarLocaleSwitcher.vue?vue&type=style&index=0&id=6edd3a5f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports